export default __webpack_public_path__ + "static/testimonial-background-95fc5cbc6207f5118263f972b171bd7e.png";